import { createSlice } from '@reduxjs/toolkit'

type TGlobalSlice = {
  isOpenMobileSidebar: boolean
}

const initialState = {
  isOpenMobileSidebar: false
} as TGlobalSlice

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    openMobileSidebar: (state) => {
      state.isOpenMobileSidebar = true
    },
    closeMobileSidebar: (state) => {
      state.isOpenMobileSidebar = false
    }
  }
})

export const globalReducer = globalSlice.reducer

export const globalActions = globalSlice.actions
